import { render, staticRenderFns } from "./PopUpMenu.vue?vue&type=template&id=6d2abe4f&scoped=true&"
import script from "./PopUpMenu.vue?vue&type=script&lang=js&"
export * from "./PopUpMenu.vue?vue&type=script&lang=js&"
import style0 from "./PopUpMenu.vue?vue&type=style&index=0&id=6d2abe4f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d2abe4f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VIcon,VMenu})


/* vuetify-loader */
import installDirectives from "!../../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import ClickOutside from 'vuetify/lib/directives/click-outside'
installDirectives(component, {ClickOutside})
